import { useState } from 'react';
import Meeting from './meeting';
import Timer from '../features/timer';

function EventCard(props) {
    let event = props.event
    const view = props.view
    const setView = props.setView
    const {event_id,event_title,event_type,event_host_name,event_time_handling,event_link,material_links,event_creator,event_admin,event_attendees,event_descr,event_votes,event_status,event_end}  =  event

    let status_class = `${event_status} status blink-faster`
    let time_class = `${event_time_handling.type} blink-slower`
    const [showAdmin , setShowAdmin] = useState(false)
    const [showDuration , setShowDuration] = useState(false)
    // const launch_date = `2023-03-01T08:00:00Z`
    const [time, setTimer] = useState('')
    // if(showDuration){Timer(end)}
    const vote = window.localStorage.getItem('vote')
    const cur_user = window.localStorage.getItem('cur_user')

    function timer(){
        var countDownDate = new Date(event_end).getTime();
        // Update the count down every 1 second
        var x = setInterval(function() {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Display the result in the element with id="demo"
        setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`)
        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            setTimer(`expired`)
        }
        }, 1000);
            }
    function eventClick(e){
        let id = e.target.value
        console.log("clicking")
        // const object = array.find(obj => obj.id === 3);
        window.localStorage.setItem('event',JSON.stringify(event))
        console.log(event)
        // props.setView(<Meeting meeting={meeting} />)
        // props.setView(<Meeting meeting={meeting} />)
        window.location.href = `/event?id=${event_id}`
        // console.log(meeting_id)
        
    }   
    if (showDuration){timer()}
        return (
        <section id="meeting-block">   
        <div className="nda-link blink-faster">
            <div>
                {/* <a href='/ndaer'> */}
                    <img src="/images/money-bill-1-wave-solid-insert_exp.svg" />
                {/* </a> */}
                pay
           </div>     
        </div>
            <div className="meeting-component color-grad-blue"
                >
                {/* ========= [Heeader]  =========*/}
                <div className="meeting-card-header">
                    <span className="meeting-title"> 
                    <div id="share-icon">
                        <img src ='/images/share-nodes-regular.svg' alt="Share event icon"></img>
                    </div>
                        <span id="meeting-title"><b>"{event_title}"</b></span></span>
                    
                    <h6>{event_host_name}</h6>
                    <span>
                       {!showAdmin&&(
                        <span id="admin-tag"  className='blink' 
                            onClick={() => setShowAdmin(true)}>
                            admin &#9663;
                        </span> )}
                        {showAdmin&&( <span className="admin_info blink"
                        onClick={() => setShowAdmin(false)}
                        >{event_admin}&#9667;</span>)} 
                    </span>
                </div>
                {/* ========= [Top] =========*/}
                <div className="meeting-comp-top">
                   <div className="meeting-comp-top-left">
                       <span className={event_type}>{event_type}</span>
                    </div>
                <div>

                    </div>
                    
                   <div className="meeting-comp-top-right">
                   <span className={status_class}><span id="meeting_status"> &#x2022; {event_status} </span></span>
                    </div>
                </div>

                {/* ========= [Bottom] =========*/}
                <div className="meeting-comp-bottom">
                      {/* ========= [Bottom Center] =========*/}
                      <div onClick={(e)=>{eventClick(e)}}className="meeting-comp-btm-center color-grad-blue-text "
                      value ={event_id} 
                      >
                        enter
                     </div>
                    {/* ========= [Bottom Left]  =========*/}
                   <div className="meeting-comp-btm-left">
                        <span className = "meeting-attendees" id="meeting-attendees">
                            attendees: {event_attendees.length}
                        </span>
                    </div>
                  
                    {/* ========= [Bottom Right] =========*/}
                   <div className="meeting-comp-btm-right">  
                   <span>
                       {!showDuration&&(
                        <span className={time_class} id="time_handling" 
                            onClick={() => 
                            setShowDuration(true)}>
                            &#9663; {event_time_handling.type}-time 
                        </span> )}
                        {showDuration&&( 
                            <span className= {time_class} id="time_handling"
                            onClick={() => setShowDuration(false)}
                            >&#9657; {time}</span>)} 
                    </span> 
                    </div>
                </div>

            </div>
        </section>
  );
}
export default EventCard;